import React from 'react';

import { CenteredColumn } from '@coachhubio/nova-flex';
import { paddingTop } from '@coachhubio/nova-spaces';
import { Text } from '@coachhubio/nova-text';
import { Link } from 'components/Nova/Link';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useDashboard } from './context/DashboardContext';
import { NoProgramsSvg } from './NoProgramsSvg';

const StyledHeading = styled.div`
  width: 308px;
  text-align: start;
`;

const Heading = styled(Text)`
  line-height: 24px;
  width: 100%;
  height: auto;
`;

const StyledCenteredColumn = styled(CenteredColumn)`
  width: 308px;
  display: flex;
  align-items: flex-start;

  ${paddingTop('2xl')}
`;

const StyledRelativeInlineBlock = styled.div`
  position: relative;
  display: inline-block;
`;

export function DashboardSectionsNoInsights() {
  const { t } = useTranslation('Dashboard');
  const { isOpsUser, hasBudget } = useDashboard();

  return (
    <>
      <StyledCenteredColumn gap="s">
        <StyledHeading>
          <Heading size="m" modifier="bold" color="text-color-default" type="heading">
            {t('dashboard.noinsights.title')}
          </Heading>
        </StyledHeading>
        <Text size="s" color="text-color-subdued">
          {t('dashboard.noinsights.description')}
        </Text>
        {(isOpsUser || hasBudget) && (
        <Link href="/programs">
            <StyledRelativeInlineBlock>
              <Text size="s" color="text-color-link-default" type="text">
                <b>{t('dashboard.noinsights.cta')}</b>
              </Text>
            </StyledRelativeInlineBlock>
          </Link>
        )}
      </StyledCenteredColumn>
      <CenteredColumn>
        <NoProgramsSvg />
      </CenteredColumn>
    </>
  );
}
